import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { User } from "../models/user_model";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";
import { module_names } from "src/app/shared/sidebar/ModuleNamesInDB";
import { ROUTES } from "src/app/shared/sidebar/menu-items";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";

@Injectable()
export class OpUsersService {
  constructor(private http: HttpClient) {}
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  getAllUser(pageId) {
    let url = environment.URL + "/user/getall?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  userRecordById(userId) {
    let url = environment.URL + "/user/edit/" + userId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveUser(bodyParams: User) {
    let url = environment.URL + "/user/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  createClientInformation(bodyParams: any) {
    let url = environment.URL + "/user/createMultipleManagers";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  createHeadOfficeClientInformation(bodyParams: any) {
    let url = environment.URL + "/user/createMultipleManagersForHeadOffice";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateUser(bodyParams: User) {
    let url = environment.URL + "/user/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  deleteUser(bodyParams: User) {
    let url = environment.URL + "/user/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url =
      environment.URL + "/user/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getUserTypes() {
    let url = environment.URL + "/usertype/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  getUserRolesNPermissionFormMenu() {
    this.sidebarnavItems = [];
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let userRolesInfo = JSON.parse(
      sessionStorage.getItem("userRolesNPermissions")
    );
    if (userInfo.user_type_id == 2) {
      let homeItem = {
        path: "/AdminPanel/home",
        title: "Home",
        icon: "mdi mdi-view-dashboard",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.home_module,
      };
      this.sidebarnavItems.push(homeItem);
      if (userInfo.show_proofcards == "true") {
        let proofcardItem = {
          path: "/AdminPanel/manager-job",
          title: "Proofcard",
          icon: "mdi mdi-cards",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: "ManagerProofcard",
        };
        this.sidebarnavItems.push(proofcardItem);
      }
      if (userInfo.show_vouchers == "true") {
        let voucherItem = {
          path: "/AdminPanel/manager-voucher",
          title: "Vouchers",
          icon: "mdi mdi-wallet-giftcard",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: "ManagerVoucher",
        };
        this.sidebarnavItems.push(voucherItem);
      }
      if (userInfo.show_orders == "true") {
        let nurseryManagerOrder = {
          path: "/AdminPanel/manager-job-orders",
          title: "Orders",
          icon: "fab fa-first-order",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: "ManagerOrder",
        };
        this.sidebarnavItems.push(nurseryManagerOrder);
      }
      //

      //ROUTES.forEach(menuElement => {
      //   if (userInfo.show_orders == "true") {
      //     if (menuElement.moduleName == module_names.order_module) {
      //       this.sidebarnavItems.push(menuElement)
      //     }
      //   } if (userInfo.show_vouchers == "true") {
      //   if (menuElement.moduleName == module_names.voucher_module) {
      //     this.sidebarnavItems.push(menuElement)
      //   }
      // }
      // });

      if (userInfo.show_posters == "true") {
        let posterItem = {
          path: "/AdminPanel/manager-poster",
          title: "Poster",
          icon: "mdi mdi-cards-variant",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: "ManagerPoster",
        };
        this.sidebarnavItems.push(posterItem);
      }
      return (this.sidebarnavItems = this.sidebarnavItems);
    } else if (userInfo.user_type_id == 3) {
      let homeItem = {
        path: "/AdminPanel/home",
        title: "Home",
        icon: "mdi mdi-view-dashboard",
        class: "",
        extralink: false,
        submenu: [],
        moduleName: module_names.home_module,
      };
      ROUTES.forEach((menuElement) => {
        if (menuElement.moduleName == module_names.home_module) {
          this.sidebarnavItems.push(homeItem);
        } else {
          const moduleElement = userRolesInfo[menuElement.moduleName];
          if (moduleElement != null || moduleElement != undefined) {
            const subMenuDataForCurrentMenuElement = menuElement.submenu;
            menuElement.submenu = [];
            this.sidebarnavItems.push(menuElement);
            if (subMenuDataForCurrentMenuElement.length > 0) {
              subMenuDataForCurrentMenuElement.forEach((subMenuElement) => {
                const subModuleElement =
                  userRolesInfo[subMenuElement.moduleName];
                if (subModuleElement != null || subModuleElement != undefined) {
                  this.sidebarnavItems[
                    this.sidebarnavItems.indexOf(menuElement)
                  ].submenu.push(subMenuElement);
                }
              });
            }
          }
        }
      });

      return (this.sidebarnavItems = this.sidebarnavItems);
    } else if (userInfo.user_type_id == 4) {
      const moduleForHeadOffice = [
        {
          path: "/AdminPanel/home",
          title: "Home",
          icon: "mdi mdi-view-dashboard",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: module_names.home_module,
        },
        {
          path: "/AdminPanel/head-office-calendar",
          title: "Calendar",
          icon: "mdi mdi-calendar-text",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: module_names.ho_bookingcalender_module,
        },
        {
          path: "/AdminPanel/head-office-order-stats",
          title: "Order Stats",
          icon: "fab fa-first-order",
          class: "",
          extralink: false,
          submenu: [],
          moduleName: module_names.ho_orderstats_module,
        },
      ];

      moduleForHeadOffice.forEach((element) => {
        this.sidebarnavItems.push(element);
      });
      return (this.sidebarnavItems = this.sidebarnavItems);
    }
    return (this.sidebarnavItems = this.sidebarnavItems);
  }

  // retrievePermission(): Observable<any> {
  //   return this.userRolesNPermission.asObservable();
  // }
  retrievePermission() {
    return JSON.parse(sessionStorage.getItem("userRolesNPermissions"));
  }
  getUserInfo() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return userInfo;
  }
  getSelectedSiteId() {
    let siteId = sessionStorage.getItem("selectedSiteId");
    return siteId;
  }

  getCustomerUserInfo() {
    let userInfo = null;
    if (
      sessionStorage.getItem("account-user") != null &&
      sessionStorage.getItem("account-user") != undefined
    ) {
      return (userInfo = JSON.parse(sessionStorage.getItem("account-user")));
    } else {
      return userInfo;
    }
  }

  getCustomerLoginForAdmin(email) {
    let url = environment.URL + "/byEmail/" + email;
    return this.http.get(url, { headers: this.myHeaders });
  }

  editOrderByAdmin(email, orderId) {
    let url = environment.URL + "/editOrder/" + email + "/" + orderId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getPhotographerList() {
    let url = environment.URL + "/job/getallPhotographers";
    return this.http.get(url, { headers: this.myHeaders });
  }

  sendUserLoginInfo(bodyParams: any) {
    let url =
      environment.URL +
      "/siteGroup/sendHeadOfficeLoginDetails/" +
      bodyParams.siteGroupId +
      "/" +
      bodyParams.userId;
    return this.http.get(url, { headers: this.myHeaders });
  }
}
